import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <i className="ri-book-read-line text-primary-500 text-2xl"></i>
              <span className="text-lg font-bold text-background-50" style={{ fontFamily: 'var(--font-heading)' }}>
                韩漫在线
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-300">
              享受极速在线观看，免费下拉式阅读搭配智能预加载，确保各种网络环境下流畅浏览，看韩漫就上韩漫网站。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">漫画分类</h4>
            <ul className="space-y-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200 whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/category/completed" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200">
                  完结漫画
                </Link>
              </li>
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-400 hover:text-accent-500 transition-colors duration-200">
                  热门恋爱
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-mail-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                contact@hanmanonline.com
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-400">
                <i className="ri-wechat-line text-accent-500 w-4 h-4 flex items-center justify-center"></i>
                微信公众号：hanmanonline
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2024-2026 韩漫在线 hanmanonline.com 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors duration-200" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-accent-500 transition-colors duration-200" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}